(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-facet-toggle]').forEach(function (btn) {
    var drawerId = btn.getAttribute('aria-controls');
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;
    var panel = drawer.querySelector('.facet-drawer__panel');

    function openDrawer() {
      drawer.setAttribute('data-was-open', '');
      drawer.removeAttribute('hidden');
      document.body.classList.add('facet-open');
      btn.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.focus();
      }
    }

    function closeDrawer() {
      drawer.setAttribute('hidden', '');
      document.body.classList.remove('facet-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    }

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    drawer.querySelectorAll('[data-facet-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) {
        closeDrawer();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
